import { render, staticRenderFns } from "./ShipperEditForm.vue?vue&type=template&id=444683d6&"
import script from "./ShipperEditForm.vue?vue&type=script&lang=js&"
export * from "./ShipperEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports